/**
 * APPLE PAY INSIDE AN APP, FOR ONE DEVICE, FOR A WHILE (2026-11-02). The owner: "is the apple pay enabled for flows from
 * the in-app in facebook/instagram? … can you enable it for a while … and try the flow". Every shopper keeps the rule of
 * 2026-09-29 (no wallet inside Instagram's or Facebook's browser). A link opened once inside the app — `?walletTest=on`
 * on any shop page — marks THIS device's copy of that app's browser for three days; `?walletTest=off` ends it sooner.
 * The mark is the end time, kept in that browser's localStorage; nothing is sent anywhere.
 */
const KEY = 'stylon:walletTest';
export const WALLET_TEST_DAYS = 3;

const local = () => {
  try { return typeof window !== 'undefined' ? window.localStorage : null; } catch (e) { return null; }
};

export function walletTestOn(storage = local(), now = Date.now()) {
  try {
    const until = Number(storage ? storage.getItem(KEY) : NaN);
    return Number.isFinite(until) && until > now;
  } catch (e) {
    return false;
  }
}

export function applyWalletTestFromUrl(search = typeof window !== 'undefined' ? window.location.search : '', storage = local(), now = Date.now()) {
  try {
    const v = new URLSearchParams(search || '').get('walletTest');
    if (!storage || !v) return;
    if (v === 'on') storage.setItem(KEY, String(now + WALLET_TEST_DAYS * 24 * 3600 * 1000));
    else if (v === 'off') storage.removeItem(KEY);
  } catch (e) { /* no storage: the test stays off */ }
}

/**
 * A PHONE WHERE APPLE PAY FAILED INSIDE AN APP (2026-11-02). The browser answers "this phone has Apple Pay"
 * (`canMakePayments`) inside Instagram's browser too, and the payment may still not complete there — the 2026-09-27
 * sheet nobody answered. So once an attempt fails inside an app on this phone (the merchant check never answered, the
 * sheet never opened, the session refused), the shop's in-app switch no longer offers it here for thirty days: the card.
 * A shopper's own cancel is not a failure. Kept in that app's browser, as the end time; nothing is sent.
 */
const FAILED_KEY = 'stylon:applePayInAppFailed';
export const APPLE_PAY_FAILED_DAYS = 30;

export function applePayFailedHere(storage = local(), now = Date.now()) {
  try {
    const until = Number(storage ? storage.getItem(FAILED_KEY) : NaN);
    return Number.isFinite(until) && until > now;
  } catch (e) {
    return false;
  }
}

export function rememberApplePayFailedHere(storage = local(), now = Date.now()) {
  try {
    if (storage) storage.setItem(FAILED_KEY, String(now + APPLE_PAY_FAILED_DAYS * 24 * 3600 * 1000));
  } catch (e) { /* no storage: nothing to remember with */ }
}

/**
 * GOOGLE PAY IN THE SHOP CHECKOUT, ON THE TEST DEVICE (2026-11-03). Off for every shopper since the owner's 2026-10-12
 * "don't show it as it's not working"; the device marked by `?walletTest=on` sees it, so it can be proved first.
 */
export function shopCheckoutOffersGooglePay(storage = local(), now = Date.now()) {
  return walletTestOn(storage, now);
}
